import React from 'react';
import PropTypes from 'prop-types';
import { ProTile } from '@thd-olt-component-react/project-summary';
import { Carousel } from '@one-thd/sui-carousel';
import classNames from 'classnames';
import { projectPropType } from '../dataModel';

const { arrayOf } = PropTypes;

const DesktopCarousel = ({ projects }) => {
  return (
    <div id="DesktopCarousel" data-testid="DesktopCarousel" className="[&_.swiper-slide]:sui-w-auto">
      <Carousel
        type="peek"
        layout="full-bleed"
        containerId="DesktopCarousel"
        slidesPerView="auto"
        slidesPerGroup={1}
        spaceBetween={0}
        breakpoints={{
          sm: { slidesPerGroup: 1, slidesPerView: 'auto' },
          md: { slidesPerGroup: 1, slidesPerView: 'auto' },
          lg: { slidesPerGroup: 1, slidesPerView: 'auto' },
          xl: { slidesPerGroup: 1, slidesPerView: 'auto' },
          '2xl': { slidesPerGroup: 1, slidesPerView: 'auto' },
        }}
        disableMargin
      >
        {projects && projects.map((project, index) => (
          <div
            key={project.projectId}
            className={classNames('sui-w-80 @xl:sui-w-96 @3xl:sui-w-96 [&>div]:sui-h-full', {
              'sui-mr-4': index !== projects.length - 1,
            })}
          >
            <ProTile
              projectId={project.projectId}
              project={project}
              maxThumbnails={4}
              impressionName="ProjectsOverview"
              position={index + 1}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

DesktopCarousel.propTypes = {
  projects: arrayOf(projectPropType),
};

DesktopCarousel.defaultProps = {
  projects: [],
};

export default DesktopCarousel;
